import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

export default function ArticleCard({ article }: { article: Article }) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-accent-300 cursor-pointer"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          title={`${article.title} - 三上悠亚粉丝站`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2 py-1 text-xs font-label rounded-full bg-accent-500 text-background-50">
            {article.tags[0]}
          </span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-base font-heading font-semibold text-foreground-900 line-clamp-2 group-hover:text-accent-600 transition-colors leading-snug">
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {article.summary}
        </p>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-400">
          <span>{article.publishedAt}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {article.readCount.toLocaleString()}
          </span>
        </div>
      </div>
    </Link>
  );
}